import { CssBaseline } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import SiteBranding from '../../base/branding/sitebranding';
import Footer from '../../base/layout/Footer';

import './Auth.scss';

export default function ThankYou() {
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email ?? '';

  return (
    <>
      <CssBaseline />
      <div className='auth auth--centered'>
        <div className='auth-brand' style={{ marginBottom: 20 }}>
          <SiteBranding />
        </div>

        <div className='auth-card auth-thankyou'>
          <div className='auth-thankyou__icon'>
            <CheckCircleOutlineIcon />
          </div>

          <h1 className='auth-thankyou__title'>Thank you!</h1>
          <p className='auth-thankyou__body'>Your request has been received and will be processed as soon as possible.</p>
          {email && (
            <p className='auth-thankyou__body'>
              Once your account has been approved, a notification will be sent to <strong>{email}</strong>.
            </p>
          )}
          <p className='auth-thankyou__body'>You may now close this window.</p>

          <div className='auth-switch'>
            Back to
            <RouterLink to='/login'>Sign in</RouterLink>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
